<template>
    <v-dialog v-model="dialog" persistent max-width="700px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" tile outlined dark x-large v-bind="attrs" v-on="on">
                <v-icon left>mdi-calendar-import</v-icon> Submit Schedule Entries
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline"><v-icon left>mdi-calendar-import</v-icon> Add Schedule Entries</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            Create schedule on:
                            <date-picker v-model="date" lang="en" value-type="format" type="date" format="ddd, YYYY-MM-DD"
                                :range=isDateRange :default-value="new Date()">
                            </date-picker>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <span class="text--caption">*10:00 p.m. is the latest start time.</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            at
                            <date-picker v-model="time" lang="en" :time-picker-options="{
                                start: '09:00',
                                step: '00:30',
                                end: '23:00',
                            }" type="time" value-type="format" range format="hh:mm a" :disabled-time="notBeforeNineOClock"
                                placeholder="Select from 9:00 AM - 11:00 PM" width="200">
                            </date-picker>
                        </v-col>
                    </v-row>
                    <v-row class="fill-height">
                        <v-col cols="8" sm="8" md="8">
                            <v-select v-model="selectedOption" :items="options" label="Outlined style" solo></v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-checkbox v-model="is_update_meeting_url" label="Update your meeting url?">
                        </v-checkbox>
                    </v-row>
                    <v-row v-if="is_update_meeting_url">
                        <v-text-field label="Meeting URL" v-model="meeting_url" hide-details="auto"></v-text-field>
                    </v-row>
                    <div v-if="errorMsg" class="error-msg">
                        {{ errorMsg }}
                    </div>

                </v-container>
                <v-progress-linear indeterminate color="cyan" v-if="isSending"></v-progress-linear>

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                <v-btn color="blue darken-1" text @click="submitDate">Submit</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import store from '../store'
import { post_service_provider_schedule, get_service_provider_meeting_url } from '../api'
import logger, { describeApiError } from '../utils/logger'


export default {
    components: {
        DatePicker
    },
    computed: {
        isDateRange: function () {
            if (this.selectedOption === 'Set a date range') {
                return true
            }
            return false
        }
    },
    data() {
        return {
            errorMsg: '',
            isSending: false,
            selectedOption: 'Does not repeat',
            options: ['Does not repeat', 'Repeat for the whole week', 'Repeat for the whole month', 'Set a date range'],
            is_update_meeting_url: false,
            date: new Date(),
            time: '',
            dialog: false,
            meeting_url: ''
        }
    },
    methods: {
        notBeforeNineOClock(date) {
            return date.getHours() < 9;
        },
        notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
        },
        submitDate() {
            this.errorMsg = ''
            this.isSending = true
            if (this.time === '') {
                this.errorMsg = 'Please specify schedule date and time'
                this.isSending = false
                return
            }

            var start_date;
            var end_date;
            if (this.selectedOption === 'Set a date range') {
                start_date = new moment(`${this.date[0]} ${this.time[0]}`, 'ddd, YYYY-MM-DD hh:mm a')
                end_date = new moment(`${this.date[1]} ${this.time[1]}`, 'ddd, YYYY-MM-DD hh:mm a')
            } else {
                start_date = new moment(`${this.date} ${this.time[0]}`, 'ddd, YYYY-MM-DD hh:mm a')
                end_date = new moment(`${this.date} ${this.time[1]}`, 'ddd, YYYY-MM-DD hh:mm a')
            }
            const schedule = {
                start_date: start_date.toISOString(),
                end_date: end_date.toISOString(),
                meeting_url: this.meeting_url
            }

            const jwt = store.getters.getJwt
            post_service_provider_schedule(jwt, schedule).then(
                () => {
                    this.dialog = false
                    this.isSending = false
                    this.$router.go()
                }
            ).catch(error => {
                logger.error('SubmitSchedule', 'Failed to submit schedule', describeApiError(error))
                store.dispatch('notification/notifyError', error)
                this.isSending = false
            })

        }

    },
    mounted() {
        const jwt = store.getters.getJwt
        get_service_provider_meeting_url(jwt).then(
            response => {
                this.meeting_url = response.data.sp_meeting_url
            }
        )
    }

}
</script>

<style scoped>
.error-msg {
    color: red;
    font-weight: bold;
}
</style>
